import { BlockedTimeWindow } from 'common/constants';
import { CalendarDateRange } from '../date-range-picker/models/types';
export enum ReplayBannerType {
  NoBanner = "NoBanner",
  Dismissible = "Dismissible",
  NonDismissible = "NonDismissible",
}
export function getBannerTypeToDisplay(blockedReplayFrames: BlockedTimeWindow[], dateRange?: CalendarDateRange): ReplayBannerType {
  if (!blockedReplayFrames || blockedReplayFrames.length === 0) {
    return ReplayBannerType.NoBanner;
  }
  const nowInSeconds = Math.floor(new Date().getTime() / 1000);
  const end = getReplayDateRangeEnd(dateRange);
  const blockedReplayFramesForUsageGreaterThan1Pct = blockedReplayFrames.filter(blockedFrame => blockedFrame.usage_pct >= 1);
  const blockedReplayFramesForUsageLessThan1Pct = blockedReplayFrames.filter(blockedFrame => blockedFrame.usage_pct < 1);
  for (const blockedFrame of blockedReplayFramesForUsageGreaterThan1Pct) {
    if (end >= blockedFrame.start && end <= blockedFrame.end) {
      return ReplayBannerType.NonDismissible;
    }
  }
  for (const blockedFrame of blockedReplayFramesForUsageLessThan1Pct) {
    if (nowInSeconds <= blockedFrame.end) {
      return ReplayBannerType.Dismissible;
    }
  }
  return ReplayBannerType.NoBanner;
}
export function getReplayDateRangeEnd(dateRange: CalendarDateRange | undefined): number {
  if (dateRange) {
    const dt = new Date(dateRange.to as string);
    return Math.floor(dt.getTime() / 1000);
  }
  return Math.floor(new Date().getTime() / 1000);
}